<template>
  <div class="home-box">
    <div class="logo-box">
      <img :src="bankInfo.logoUrl" />
    </div>
    <div class="desc-box">
      <div class="name">{{bankInfo.bankName}}</div>
      <div class="desc">{{bankInfo.couponDesc}}</div>
    </div>
    <div class="apply-box">
      <div class="card-list">
        <van-swipe :autoplay="3000" class="swipe-box">
          <van-swipe-item v-for="(item, index) in cardList" :key="index" @click="handleCard(item)">
            <img class="card-img" :src="item.url" />
          </van-swipe-item>
        </van-swipe>
        <img src="http://oss.aqdpay.com/appweb/modelCreditCard/apply.png" alt="立即申请" class="apply-btn" @click="goApp" />
      </div>
      <div class="rule-box">
        <!-- 活动权益 -->
        <div v-if="bankInfo.rightsUrl" class="ac-rules">
          <img :src="bankInfo.rightsUrl" alt="">
        </div>
        <!-- 活动详情 -->
        <div v-if="bankInfo.ruleUrl" class="ac-rules">
          <img :src="bankInfo.ruleUrl" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swipe, SwipeItem } from 'vant'

export default {
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
  data () {
    return {
      bankInfo: {
        logoUrl: 'https://oss.aqdpay.com/appweb/modelCreditCard/qd/mslogo.png',
        bankCode: 'CMBC',
        bankName: '申请青岛银行信用卡',
        couponDesc: '送120元优惠券',
        rightsUrl: 'https://oss.aqdpay.com/appweb/modelCreditCard/qd/msrights.png',
        ruleUrl: 'https://oss.aqdpay.com/appweb/modelCreditCard/qd/msrule.png'
      },
      bankList: [
        {
          id: 'CMBC',
          logoUrl: 'https://oss.aqdpay.com/appweb/modelCreditCard/qd/mslogo.png',
          bankCode: 'CMBC',
          bankName: '申请青岛银行信用卡',
          couponDesc: '送120元优惠券',
          rightsUrl: 'https://oss.aqdpay.com/appweb/modelCreditCard/qd/msrights.png',
          ruleUrl: 'https://oss.aqdpay.com/appweb/modelCreditCard/qd/msrule.png'
        }
      ],
      cardList: [
        {
          id: 'CMBC',
          bankCode: 'CMBC',
          name: '青岛银行信用卡',
          url: 'https://oss.aqdpay.com/appweb/modelCreditCard/qd/1.png'
        }
      ]
    }
  },
  methods: {
    // 切换卡片
    handleCard (item) {
      const info = this.bankList.find((info) => item.bankCode === info.bankCode)
      this.bankInfo = info
    },
    // 跳转便捷青岛APP
    goApp () {
      if (window._czc) {
        window._czc.push(['_trackEvent', '青岛银行信用卡活动', '立即申请APP-青岛银行信用卡', '青岛银行信用卡活动首页', '', '20220520AD'])
      }
      window.location.href = 'bjqd://'
      setTimeout(function () {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
      }, 1200)
    }
  }
}
</script>
<style lang="scss" scoped>
.home-box {
  position: relative;
  min-height: 100vh;
  background: #ff7253 url('https://oss.aqdpay.com/appweb/modelCreditCard/bg.png') no-repeat;
  background-size: 100%;
  overflow-x: hidden;
}
.logo-box {
  img {
    width: 100%;
  }
}
.desc-box {
  margin: 15px 0;
  font-size: 30px;
  color: #FEDDA8;
  line-height: 1.6;
  .name {
    text-align: center;
  }
  .desc {
    text-align: center;
  }
}
.apply-box {
  position: relative;
}
.rights-desc {
  margin: 15px 0;
  font-size: 15px;
  color: #FEDDA8;
  text-align: center;
}
.card-list {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 350px;
  background: url('http://oss.aqdpay.com/appweb/modelCreditCard/red.png') no-repeat;
  background-size: 100% 100%;
  padding-top: 12%;
}
.swipe-box {
  width: 60%;
  height: 144px;
  margin: 0 auto;
}
.card-img {
  width: 100%;
  max-height: 100%;
  margin: 0 auto;
}
.apply-btn {
  position: absolute;
  bottom: 10%;
  left: 50%;
  width: 70px;
  height: 70px;
  transform: translateX(-50%);
}
.rule-box {
  margin: 15px 0;
}
.ac-rules {
  margin: 15px;
  img {
    width: 100%;
  }
}
.share-box {
  position: absolute;
  top: 2.1%;
  right: 3.5%;
  img {
    width: 24px;
    height: 24px;
  }
}
</style>
